import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {offerDetailBrandButtonStyle} from "../atoms/OfferStickyBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {onButtonClick} = props;

    const {isMobile} = useUserDevice();

    return (
        <Button
            className={offerDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={onButtonClick}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_CONSTRUCTION_GALLERY_BUTTON}
        >
            Zdjęcia z budowy
        </Button>
    );
};
import {Button} from "@pg-design/button-module";
import {ConstructionHelmetIcon} from "@pg-design/icons-module";
import {OFFER_TEST_IDS} from "@pg-mono/test-ids";
import {useUserDevice} from "@pg-mono/user-device";

import {offerDetailBrandButtonStyle} from "../atoms/OfferStickyBar";

interface Props {
    onButtonClick: () => void;
}

export const DetailConstructionGalleryCTA = (props: Props) => {
    const {onButtonClick} = props;

    const {isMobile} = useUserDevice();

    return (
        <Button
            className={offerDetailBrandButtonStyle}
            iconLeft={ConstructionHelmetIcon}
            variant="brand_icon"
            size={isMobile ? "medium" : "big"}
            onClick={onButtonClick}
            dataTestId={OFFER_TEST_IDS.OFFER_VIEW.OPEN_CONSTRUCTION_GALLERY_BUTTON}
        >
            Zdjęcia z budowy
        </Button>
    );
};
